import highEmphasis from '../../../../text/high-emphasis';

const custom = (params) => highEmphasis(params);

export default custom;
